import React, { useState } from 'react';
import { Form, Input } from 'antd';
import AuthButton from '../../components/AuthButton';
import loginAction from './store/signinActions';
import { useDispatch } from 'react-redux';
import { type AppDispatch } from '../../redux/store';
import {
  UserOutlined,
  LockOutlined,
  SafetyOutlined,
  ArrowRightOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import BrandLogo from '../../assets/images/goldpulse_logo.png';
import AuthHero from '../../components/AuthHero';
import useCardTilt from '../../components/AuthHero/useCardTilt';
import JewelBackdrop from '../../components/AuthHero/JewelBackdrop';
import './index.scss';

const SignInPage: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const [form] = Form.useForm();

  const [isLoading, setIsLoading] = useState(false);

  const { containerRef, onMouseMove, onMouseLeave } = useCardTilt();

  const onFinish = async (values: { userName: string; password: string }) => {
    setIsLoading(true);
    const action = loginAction;
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    const response: {
      branch: any;
      role: string;
      token: string;
      username: string;
      branches: any;
      organizationName: string;
      organizationLogo: string;
    } = await action(dispatch, {
      ...values,
      userName: values.userName.trim(),
    });
    if (response?.token !== undefined) {
      window.localStorage.setItem('token', response.token);
      window.localStorage.setItem('role', response.role);
      window.localStorage.setItem('branch', JSON.stringify(response.branch));
      window.localStorage.setItem(
        'branches',
        JSON.stringify(
          Array.isArray(response.branches)
            ? response.branches.filter((b: any) => b?.status !== 'deactive')
            : response.branches
        )
      );
      window.localStorage.setItem(
        'branchCount',
        String(Array.isArray(response.branches) ? response.branches.length : 0)
      );
      window.localStorage.setItem('username', response.username);
      window.localStorage.setItem(
        'organizationName',
        response.organizationName
      );
      window.localStorage.setItem(
        'organizationLogo',
        response.organizationLogo
      );
      switch (response.role) {
        case 'superadmin':
          navigate('/');
          break;
        case 'cashier':
          navigate('/transaction');
          break;
        case 'billing':
          navigate('/loan');
          break;
        case 'auditor':
          navigate('/');
          break;
        case 'manager':
          navigate('/');
          break;
        case 'approver':
          navigate('/loan');
          break;
        case 'recovery':
          navigate('/recovery');
          break;
      }
    }
    setIsLoading(false);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <div
      className="sign-in-container"
      ref={containerRef}
      onMouseMove={onMouseMove}
      onMouseLeave={onMouseLeave}
    >
      <div className="bg-stripe" />
      <div className="bg-red">
        <JewelBackdrop />
        <span className="orb orb-1" />
        <span className="orb orb-2" />
      </div>
      <div className="cursor-glow" />
      <span className="sparkle sparkle-1" />
      <span className="sparkle sparkle-2" />
      <span className="sparkle sparkle-3" />

      <header className="top-bar">
        <div className="brand">
          <img src={BrandLogo} alt="Gold Pulse" />
        </div>
        <div className="request-pill">
          New here? <span
            className="signup-link"
            role="link"
            tabIndex={0}
            onClick={() => {
              navigate('/sign-up');
            }}
          >
            Sign up
          </span>
        </div>
      </header>

      <AuthHero />

      <div className="form-container">
        <div className="form-card">
        <p className="eyebrow">
          <SafetyOutlined /> SECURE SIGN-IN
        </p>
        <p className="title">Welcome back</p>
        <p className="subtitle">Sign in to your account to continue.</p>
        <Form
          form={form}
          name="signin_form"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            name="userName"
            rules={[{ required: true, message: 'Please enter your username' }]}
          >
            <Input
              className="signin__input"
              placeholder="Username"
              prefix={
                <UserOutlined style={{ color: '#64748B', marginRight: 8 }} />
              }
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password
              className="signin__input"
              placeholder="Password"
              prefix={
                <LockOutlined style={{ color: '#64748B', marginRight: 8 }} />
              }
            />
          </Form.Item>

          <div className="form-options">
            <span
              className="forgot-link"
              role="link"
              tabIndex={0}
              onClick={() => {
                navigate('/forgot-password');
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') navigate('/forgot-password');
              }}
            >
              Forgot password?
            </span>
          </div>

          <Form.Item>
            <AuthButton
              htmlType="submit"
              
            loading={isLoading}
 loadingText="Signing in...">
              Sign In <ArrowRightOutlined />
            </AuthButton>
          </Form.Item>
        </Form>
        </div>
      </div>
    </div>
  );
};

export default SignInPage;
